import React, { createContext, useEffect, useLayoutEffect, useState, useContext } from 'react';
import axios from 'axios';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppContext } from "./AppContext.jsx";
import { useApiContext } from "./ApiContext.jsx";
import { showMain, hideMain, i18n } from '../helpers/HelperFunctions.js';

export const AuthContext = createContext(null);
const queryClient = new QueryClient();

export const AuthWrapper = ({ children }) => {
	const { api } = useApiContext();
	const { token, sessionId } = useContext(AppContext);
	const [sessionInfo, setSessionInfo] = useState(null);
	const [bearerInitialized, setBearerInitialized] = useState(false);
	

	useEffect(() => {
		if (token?.access_token) {
			api.defaults.headers.common.Authorization = `Bearer ${token.access_token}`;
			setBearerInitialized(true)
		} else {
			delete api.defaults.headers.common.Authorization;
		}
	}, [token]);


	useEffect(() => {
		if (!bearerInitialized) return;
		
		api.get(`/api/trivia/session-info`).then(res => {
			setSessionInfo(res.data)
		});

		//axios.get(`/react-app/json/session-info.json`).then(res => {
		//	setSessionInfo(res.data)
		//});

	}, [bearerInitialized]);

	return ( 
		<AuthContext.Provider
			value={{
				sessionInfo,
				setSessionInfo
			}}
		>
			<QueryClientProvider client={queryClient}>
				{children}
			</QueryClientProvider>
		</AuthContext.Provider>
	);
};
